if (!customElements.get("kit-variant-selector")) {
  customElements.define(
    "kit-variant-selector",
    class KitVariantSelector extends HTMLElement {
      constructor() {
        super();

        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

        this.kitItemsSlider = this.querySelector("glide-component");
        this.kitItems = this.querySelectorAll("kit-item");
        this.querySelectorAll(`input[type="radio"]`).forEach((radio) => {
          radio.addEventListener("change", this.handleVariantChanges.bind(this));
        });

        this.hideErrors = this.dataset.hideErrors === "true";

        this.productImages = document.querySelectorAll("media-gallery .product__media-item");

        this.nextButton = this.querySelector(".product-form__next-btn");
        this.nextButton.addEventListener("click", this.onNextHandler.bind(this));
        this.previousButton = this.querySelector(".product-form__previous-btn") ?? null;
        if (this.previousButton) this.previousButton.addEventListener("click", this.onPreviousHandler.bind(this));

        this.submitButton = this.querySelector(".product-form__submit-btn");
        this.submitButton.addEventListener("click", this.onSubmitHandler.bind(this));
        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

        // handle price groups
        if (this.dataset.productsWithPriceGroups) {
          this.priceAdjustment = 0;
          this.markdownAdjustment = 0;
          this.productsWithPriceGroups = this.dataset.productsWithPriceGroups.split("|");
          this.kitPrice = parseInt(this.dataset.kitPrice || "0");
          this.kitCompareAtPrice = parseInt(this.dataset.kitCompareAtPrice || "0");
          //this.initPriceGroups();
        }

        requestAnimationFrame(() => {
          this.applyInitialMinimumSelections();
          this.initializeKitItemsState();
          this.syncPriceNormalizeWithKitSelections();
          this.syncCupomKitsUpsellWithCurrentKitVariant();
          this.configButtons();

          requestAnimationFrame(() => {
            this.applyInitialGallerySelection();
            this.syncCupomKitsUpsellWithCurrentKitVariant();
          });

          window.addEventListener(
            "PromotionCouponReady",
            () => {
              this.syncCupomKitsUpsellWithCurrentKitVariant();
            },
            { once: true },
          );
        });
      }

      applyInitialMinimumSelections() {
        this.kitItems.forEach((kitItem) => {
          const variants = Array.isArray(kitItem.productVariants) ? kitItem.productVariants : [];

          if (!variants.length) return;

          const variantExistsInPicker = (variant) => {
            if (!Array.isArray(variant.options)) return false;

            return variant.options.every((optionValue, index) => {
              const position = index + 1;

              const radios = Array.from(kitItem.querySelectorAll(`input[type="radio"][data-position="${position}"]`));

              return radios.some((radio) => radio.value === String(optionValue));
            });
          };

          const candidates = variants.filter(variantExistsInPicker).filter((variant) => variant.available !== false);

          if (!candidates.length) return;

          const minimumVariant = candidates.reduce((minimum, variant) => {
            if (!minimum) return variant;

            const minimumPrice = Number(minimum.price || 0);
            const variantPrice = Number(variant.price || 0);

            if (variantPrice < minimumPrice) return variant;

            return minimum;
          }, null);

          if (!minimumVariant?.options) return;

          minimumVariant.options.forEach((optionValue, index) => {
            const position = index + 1;

            const radios = Array.from(kitItem.querySelectorAll(`input[type="radio"][data-position="${position}"]`));

            const targetRadio = radios.find((radio) => radio.value === String(optionValue));

            if (targetRadio) {
              targetRadio.checked = true;
            }
          });
        });
      }

      initializeKitItemsState() {
        this.kitItems.forEach((kitItem) => {
          if (typeof kitItem.updateOptions === "function") {
            kitItem.updateOptions();
          }

          if (typeof kitItem.updateMasterId === "function") {
            kitItem.updateMasterId();
          }

          if (typeof kitItem.updatePrice === "function" && kitItem.currentVariant) {
            kitItem.updatePrice();
          }
        });
      }
      applyInitialGallerySelection() {
        const firstKitItem = this.kitItems[0];
        if (!firstKitItem || typeof firstKitItem.onVariantChange !== "function") return;

        const selectedPriorityRadio =
          firstKitItem.querySelector('input[type="radio"][data-name="Cor"]:checked') ||
          firstKitItem.querySelector('input[type="radio"][data-name="Color"]:checked') ||
          firstKitItem.querySelector('input[type="radio"][data-name="Colour"]:checked') ||
          firstKitItem.querySelector('input[type="radio"][data-name="Modelo"]:checked') ||
          firstKitItem.querySelector('input[type="radio"]:checked');

        if (!selectedPriorityRadio) return;

        firstKitItem.onVariantChange(selectedPriorityRadio);
      }
      initPriceGroups() {
        try {
          // get price adjustment for each product
          this.productsWithPriceGroups.forEach((product) => {
            const productSplit = product.split(":");
            const productHandle = productSplit[0];
            const productQnt = parseInt(productSplit[1]);

            const priceGroupCookie = this.getPriceGroupCookie(productHandle);
            if (priceGroupCookie && priceGroupCookie !== "loading") {
              this.priceAdjustment += priceGroupCookie.priceAdjustment * productQnt;
              this.markdownAdjustment += priceGroupCookie.markdownAdjustment * productQnt;
            }
          });

          const discount = this.calculateDiscount();
          if (discount) {
            this.discount = discount;
          }
        } catch (e) {
          console.error(">>>", e);
        }
      }

      calculateDiscount() {
        const kitPrice = this.kitPrice + this.priceAdjustment;
        const kitCompareAtPrice = this.kitCompareAtPrice + this.markdownAdjustment;

        const discount = Math.abs((kitPrice / kitCompareAtPrice) * 100 - 100);
        return discount;
      }

      getPriceGroupCookie(productHandle) {
        const cookieName = `statsig-group-${productHandle}`;
        const cookieValue = document.cookie
          .split("; ")
          .find((row) => row.startsWith(cookieName))
          ?.split("=")[1];

        if (cookieValue === "loading") return "loading";
        if (!cookieValue) return null;
        return JSON.parse(cookieValue);
      }
      getCurrentKitDiscount() {
        let pristinePrice = 0;
        let discountedPrice = 0;

        this.kitItems.forEach((kitItem) => {
          const quantity = Number(kitItem.quantity || 0);
          const variant = kitItem.currentVariant;
          if (!variant || quantity <= 0) return;

          const variantPrice = Number(variant.price || 0);
          const parsedDiscount = parseFloat(kitItem.dataset.discount || "0");
          const itemDiscount = Number.isNaN(parsedDiscount) ? 0 : parsedDiscount;
          const itemDiscountedPrice = variantPrice - (variantPrice * itemDiscount) / 100;

          pristinePrice += variantPrice * quantity;
          discountedPrice += itemDiscountedPrice * quantity;
        });

        if (pristinePrice <= 0) return 0;

        const effectiveDiscount = ((pristinePrice - discountedPrice) / pristinePrice) * 100;
        if (this.dataset.schemaType === "buy-x-pay-y") return effectiveDiscount;
        return Number(effectiveDiscount.toFixed(4));
      }

      get cupinnKitId() {
        const sourceFromDataset = this.dataset.cupinnKitId?.trim();
        if (sourceFromDataset) return sourceFromDataset;

        const hiddenInput = this.querySelector('input[name="properties[__kitId]"]');
        const sourceFromInput = hiddenInput?.value?.trim();
        if (sourceFromInput) return sourceFromInput;

        return null;
      }

      getProductSource() {
        const sourceFromDataset = this.dataset.productSource?.trim();
        if (sourceFromDataset) return sourceFromDataset;

        const productInfo = this.closest("product-info");
        const sourceFromProductInfo = productInfo?.dataset.productSource?.trim();
        if (sourceFromProductInfo) return sourceFromProductInfo;

        const hiddenInput = this.querySelector('input[name="properties[__productSource]"]');
        const sourceFromInput = hiddenInput?.value?.trim();
        if (sourceFromInput) return sourceFromInput;

        return "pdk";
      }
      appendProductSource(formData) {
        const productSource = this.getProductSource();
        if (!productSource) return formData;

        formData.set("properties[__productSource]", productSource);
        return formData;
      }
      getSelectedKitTotals() {
        let pristinePrice = 0;
        let compareAtPrice = 0;

        this.kitItems.forEach((kitItem) => {
          const quantity = Number(kitItem.quantity);
          const variant = kitItem.currentVariant;

          if (!variant) return;

          const variantPrice = Number(variant.price);
          const rawCompareAtPrice = Number(variant.compare_at_price || 0);
          const variantCompareAtPrice = rawCompareAtPrice > variantPrice ? rawCompareAtPrice : variantPrice;

          pristinePrice += variantPrice * quantity;
          compareAtPrice += variantCompareAtPrice * quantity;
        });

        return {
          pristinePrice,
          compareAtPrice,
        };
      }

      syncPriceNormalizeWithKitSelections() {
        const sectionId = this.closest("[data-section]")?.dataset.section;
        const scopedPriceNormalize = sectionId ? document.querySelector(`#price-${sectionId} price-normalize`) : null;
        const priceNormalize = scopedPriceNormalize || document.querySelector("price-normalize[data-placement='pdk']");
        if (!priceNormalize) return;

        const { pristinePrice, compareAtPrice } = this.getSelectedKitTotals();
        const kitDiscount = this.getCurrentKitDiscount();
        const timestamp = `kit-price-sync-${Date.now()}`;

        priceNormalize.setAttribute("data-pristine-price", String(pristinePrice));
        priceNormalize.setAttribute("data-compare-at-price", String(this.dataset.schemaType === "buy-x-pay-y" ? pristinePrice : compareAtPrice));
        priceNormalize.setAttribute("data-kit-discount", String(kitDiscount));
        priceNormalize.setAttribute("data-timestamp", timestamp);
      }
      syncCupomKitsUpsellWithCurrentKitVariant() {
        const currentKitItem = this.querySelector(`kit-item[data-index="${this.kitItemsSlider.currentIndex()}"]`);
        const variant = currentKitItem?.currentVariant;
        const variantPrice = Number(variant?.price || 0);
        const variantCompareAtPrice = Number(variant?.compare_at_price || variantPrice);
        if (!variantPrice) return;

        const upsell = document.querySelector("cupom-kits-upsell");
        if (!upsell) return;

        const timestamp = `kitUpsell:newKitVariantSync-${Date.now()}`;
        const currentKitDiscount = this.getCurrentKitDiscount();

        upsell.querySelectorAll(".upsell-kits__button").forEach((button) => {
          const buttonKitDiscount = Number(button.dataset.upsellKitsDiscount || 0);
          const isUnitButton = button.dataset.unitButton === "true";

          let kitDiscount;
          if (isUnitButton) {
            // "1 unid." button (forloop.first in Liquid): individual item, never apply kit discount
            kitDiscount = 0;
          } else if (button.classList.contains("is-active") && currentKitDiscount > 0) {
            // Active kit button: apply current kit discount
            kitDiscount = currentKitDiscount;
          } else {
            // Non-active buttons: use their own Liquid-rendered discount
            kitDiscount = buttonKitDiscount;
          }

          button.dataset.upsellPrice = String(variantPrice);
          button.dataset.upsellBasePrice = String(variantPrice);
          button.dataset.upsellCompareAtPrice = String(variantCompareAtPrice);
          button.dataset.upsellKitsDiscount = String(kitDiscount);

          const priceNormalize = button.querySelector("price-normalize");
          if (!priceNormalize) return;

          const hasButtonCoupon = Number(button.dataset.upsellKitsCoupon || 0) > 0;
          const buttonCouponCode =
            button.dataset.upsellKitsCouponCode ||
            priceNormalize.getAttribute("data-default-discount-code") ||
            priceNormalize.getAttribute("data-price-object-discount-code") ||
            "";

          if (hasButtonCoupon && buttonCouponCode) {
            priceNormalize.setAttribute("data-is-to-show-coupon-discount", "true");
            priceNormalize.setAttribute("data-default-discount-code", buttonCouponCode);
          } else if (kitDiscount > 0) {
            // Preserve previous behavior for generic coupons: do not stack over kit discount
            // unless the button has its own coupon from metafield.
            priceNormalize.setAttribute("data-is-to-show-coupon-discount", "false");
            priceNormalize.removeAttribute("data-default-discount-code");
          }
          // When button has no kit discount and no own coupon, preserve existing
          // coupon state from the promotionCoupon system (sessionStorage).

          priceNormalize.setAttribute("data-pristine-price", String(variantPrice));
          priceNormalize.setAttribute("data-min-price", String(variantPrice));
          priceNormalize.setAttribute("data-compare-at-price", String(variantCompareAtPrice));
          priceNormalize.setAttribute("data-kit-discount", String(kitDiscount));
          priceNormalize.setAttribute("data-timestamp", timestamp);
        });
      }
      handleVariantChanges(evt) {
        const currentKitItem = this.querySelector(`kit-item[data-index="${this.kitItemsSlider.currentIndex()}"]`);
        const radio = evt.target;
        // const optionValue = slugify(radio.value);

        // Show images for selected color
        currentKitItem.onVariantChange(radio);
        this.syncPriceNormalizeWithKitSelections();
        this.syncCupomKitsUpsellWithCurrentKitVariant();
        this.configButtons();
        this.updatePreOrderInfos();
      }

      onNextHandler(evt) {
        evt.preventDefault();

        const kitItem = this.querySelector(`kit-item[data-index="${this.kitItemsSlider.currentIndex()}"]`);
        if (!kitItem.optionsHaveBeenSelected()) {
          this.handleErrorMessage("Selecione uma opção para continuar");
          return;
        }
        this.handleErrorMessage();
        this.kitItemsSlider.goNext();

        this.configButtons();
        this.updatePreOrderInfos();

        const currentKitItem = this.querySelector(`kit-item[data-index="${this.kitItemsSlider.currentIndex()}"]`);
        const selectedColorRadio = currentKitItem.querySelector('input[type="radio"][data-name="Cor"]:checked');
        // trigger change event
        if (selectedColorRadio) {
          selectedColorRadio.dispatchEvent(new Event("change"));
        }
      }

      onPreviousHandler(evt) {
        evt.preventDefault();

        this.kitItemsSlider.goPrev();

        this.configButtons();
        this.updatePreOrderInfos();

        const currentKitItem = this.querySelector(`kit-item[data-index="${this.kitItemsSlider.currentIndex()}"]`);
        const selectedColorRadio = currentKitItem.querySelector('input[type="radio"][data-name="Cor"]:checked');
        // trigger change event
        if (selectedColorRadio) {
          selectedColorRadio.dispatchEvent(new Event("change"));
        }
      }

      configButtons() {
        const currentKitItem = this.querySelector(`kit-item[data-index="${this.kitItemsSlider.currentIndex()}"]`);

        // Config previous button
        if (this.previousButton) {
          if (this.kitItemsSlider.currentIndex() === 0) {
            this.previousButton.setAttribute("disabled", true);
            this.previousButton.style.display = "none";
          } else {
            this.previousButton.removeAttribute("disabled");
            this.previousButton.style.display = "block";
          }
        }

        // Config next button
        if (currentKitItem.optionsHaveBeenSelected()) {
          this.nextButton.removeAttribute("disabled");
        } else {
          this.nextButton.setAttribute("disabled", true);
        }
        if (this.kitItemsSlider.currentIndex() === this.kitItems.length - 1) {
          this.nextButton.style.display = "none";
          this.submitButton.style.display = "block";
        } else {
          this.nextButton.style.display = "block";
          this.submitButton.style.display = "none";
        }

        let selectFinished = true;
        this.kitItems.forEach((kitItem) => {
          selectFinished = selectFinished && kitItem.optionsHaveBeenSelected();
        });

        if (selectFinished && this.kitItemsSlider.currentIndex() === this.kitItems.length - 1) {
          this.submitButton.removeAttribute("disabled");
          if (this.querySelector(".product-form__wishlist")) {
            this.querySelector(".product-form__wishlist").style.display = "flex";
          }
        }
        this.updatePreOrderInfos();
      }

      clearPreOrderInfos(scope) {
        const root = scope || this;

        root.querySelectorAll(".pre-order-message-wrapper").forEach((el) => el.remove());
        root.querySelectorAll(".pre-order-date-info").forEach((el) => el.remove());
        root.querySelectorAll(".pre-order-tooltip").forEach((el) => el.remove());
        root.querySelectorAll(".pre-order-info").forEach((el) => el.remove());

        Array.from(document.querySelectorAll(".timer-container-timesact-timer-po")).forEach((_msgbox) => {
          if (!_msgbox.classList.contains("hidden")) _msgbox.classList.add("hidden");
        });
      }

      updatePreOrderTimesAct(currentKitItem) {
        const msgbox = currentKitItem.querySelector(".timer-container-timesact-timer-po");
        const msgCustomModal = document.querySelector("#pre-order-modal-text").innerHTML;
        const variantSelectorBtns = document.querySelector(".kit-variant-selector__buttons");
        msgbox.querySelector(".pre-order-date")?.closest("div").remove();
        if (currentKitItem.currentVariant?.selling_plan_allocations[0]) {
          if (msgbox.classList.contains("hidden")) {
            msgbox.classList.remove("hidden");
          }
          msgbox.querySelector("p").innerHTML = msgCustomModal.replace(
            "[prazo]",
            currentKitItem.currentVariant.selling_plan_allocations[0]?.selling_plan?.description.toUpperCase(),
          );

          let preOrderDate = variantSelectorBtns.querySelector(".pre-order-date");
          console.log("preOrderDate", preOrderDate);
          if (!preOrderDate) {
            const preOrderDiv = document.createElement("div");
            preOrderDate = document.createElement("span");
            preOrderDate.classList.add("pre-order-date");
            preOrderDate.style.color = "rgb(89, 133, 143)";

            preOrderDiv.appendChild(preOrderDate);
            msgbox.appendChild(preOrderDiv);
          }

          preOrderDate.textContent = `Entrega prevista para: ${currentKitItem.currentVariant.selling_plan_allocations[0]?.selling_plan?.description}`;

          // Adiciona o evento ao msgbox apenas uma vez
          if (!msgbox.classList.contains("modal-initialized")) {
            msgbox.addEventListener("click", function (event) {
              event.preventDefault();
              const modalBox = document.getElementById("preOrderModal");
              modalBox.style.display = "flex";
              document.body.classList.add("no-scroll");
            });
            msgbox.classList.add("modal-initialized");
          }
        } else {
          if (!msgbox.classList.contains("hidden")) {
            document.querySelectorAll(".timer-container-timesact-timer-po").forEach((_msgbox) => {
              _msgbox.classList.add("hidden");
            });
          }

          const existingPreOrderDate = msgbox.querySelector(".pre-order-date");
          if (existingPreOrderDate) {
            existingPreOrderDate.parentElement.remove();
          }
        }
      }

      updatePreOrderInfos() {
        const root = this;

        // Clean previous state
        this.clearPreOrderInfos(root);
        // Determine if ANY selected kit variant is a pre-order (matches unit product logic)
        const currentVariant = this.kitItems[this.kitItemsSlider.currentIndex()].currentVariant;
        const hasSellingPlan =
          currentVariant.selling_plan_allocations?.length > 0 &&
          currentVariant.selling_plan_allocations[0]?.selling_plan_id;
        const preOrderPrazo = currentVariant.selling_plan_allocations?.[0]?.selling_plan?.name?.replace(
          "Compra antecipada: envio a partir de ",
          "",
        );
        const preOrderValue = currentVariant.selling_plan_allocations?.[0]?.selling_plan?.description;
        const hasPreOrder = Boolean(hasSellingPlan);
        if (!hasPreOrder) return;
        if (currentVariant.selling_plan_allocations[0]?.app_id === "timesact") {
          this.updatePreOrderTimesAct(this.kitItems[this.kitItemsSlider.currentIndex()]);
          return;
        }

        // Choose the current primary action button (Next or Submit depending on step)
        const actionButton =
          (this.kitItemsSlider.currentIndex() === this.kitItems.length - 1 ? this.submitButton : this.nextButton) ||
          this.submitButton ||
          this.nextButton;

        if (!actionButton) return;

        // Insert wrapper right before the action button
        const wrapper = document.createElement("div");
        wrapper.className = "pre-order-message-wrapper";

        const msg = document.createElement("span");
        msg.className = "pre-order-message";
        msg.textContent = "Item em Compra Antecipada";

        const link = document.createElement("a");
        link.className = "pre-order-how-works";
        link.href = "#";
        link.textContent = "Como funciona?";

        const preOrderSpan = document.createElement("div");
        preOrderSpan.className = "pre-order-date-info";
        preOrderSpan.textContent = `${String(preOrderValue ? preOrderValue : preOrderPrazo)}`;

        link.addEventListener("click", (event) => {
          event.preventDefault();
          if (!window.BackorderDialogs) {
            // Fallback para não travar venda em caso de problemas com os modais
            console.error("BackorderDialogs não encontrado - openHowWorks");
            return;
          }
          window.BackorderDialogs.openHowWorks();
        });

        wrapper.appendChild(msg);
        wrapper.appendChild(link);
        wrapper.appendChild(preOrderSpan);

        // Insert after kit-variant-radios
        const radiosContainer = root.querySelectorAll("kit-variant-radios")[this.kitItemsSlider.currentIndex()];
        if (!root.querySelector(".pre-order-message-wrapper")) {
          if (radiosContainer && radiosContainer.parentElement) {
            radiosContainer.insertAdjacentElement("afterend", wrapper);
          } else {
            // fallback: insert before the action button
            actionButton.parentElement?.insertBefore(wrapper, actionButton);
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        const promoInstanceId =
          window.crypto && typeof window.crypto.randomUUID === "function"
            ? window.crypto.randomUUID()
            : `promo-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const items = {};
        let totalQty = 0;
        this.kitItems.forEach((kitItem) => {
          totalQty += kitItem.quantity;
        });
        this.kitItems.forEach((kitItem) => {
          const selectedVariant = kitItem.getSelectedVariant(totalQty);
          selectedVariant.properties = {
            ...(selectedVariant.properties || {}),
            __promoInstanceId: promoInstanceId,
          };
          if (items[selectedVariant.id]) {
            items[selectedVariant.id].quantity += selectedVariant.quantity;
          } else {
            items[selectedVariant.id] = selectedVariant;
          }
        });
        const fetchAddToCart = (items) => {
          config.body = JSON.stringify({
            items,
            sections: "cart-drawer,cart-icon-bubble",
          });
          config.headers["site-placement"] = "pdk";
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (response.items && response.items.length > 0)
                this.handleCartUpdated(response.items, response.sections);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            });
        };

        const productSource = this.getProductSource();
        const kitId = this.cupinnKitId;
        const addItems = Object.values(items).map((item) => ({
          ...item,
          properties: {
            ...(item.properties || {}),
            ...(kitId && { __kitId: kitId }),
            __productSource: productSource,
          },
        }));

        if (addItems.some((item) => item.properties["__backorder_app"] === "timesact")) {
          fetchAddToCart(addItems);
          return;
        }

        if (addItems.some((item) => !!item.selling_plan)) {
          if (!window.BackorderDialogs) {
            // Fallback para não travar venda em caso de problemas com os modais
            console.error("BackorderDialogs não encontrado - BuyButton Kit");
            fetchAddToCart(addItems);
            return;
          }

          // Build delivery message including selected color/size per pre-order item, with product name
          const deliveryLines = Array.from(this.kitItems)
            .filter((kitItem) => !!kitItem?.currentVariant?.selling_plan_allocations?.length)
            .map((kitItem) => {
              const preOrderPrazo = kitItem?.currentVariant?.selling_plan_allocations?.[0]?.selling_plan?.description
                ? kitItem?.currentVariant?.selling_plan_allocations?.[0]?.selling_plan?.description
                : kitItem?.currentVariant?.selling_plan_allocations?.[0]?.selling_plan?.name;

              const selectedColor = kitItem.querySelector('input[type="radio"][data-name="Cor"]:checked')?.value;
              const selectedSize = kitItem.querySelector('input[type="radio"][data-name="Tamanho"]:checked')?.value;

              const productName =
                kitItem.getAttribute("data-product-title") ||
                kitItem.dataset?.productTitle ||
                kitItem.querySelector(".kit-item__info h2")?.textContent?.trim() ||
                kitItem.querySelector(".product__title")?.textContent?.trim() ||
                kitItem.querySelector("[data-product-title]")?.textContent?.trim();

              const parts = [];
              if (productName) parts.push(`Produto: ${productName}`);
              if (typeof kitItem?.quantity === "number") parts.push(`Qtd: ${kitItem.quantity}`);
              if (selectedColor) parts.push(`Cor: ${selectedColor}`);
              if (selectedSize) parts.push(`Tamanho: ${selectedSize}`);

              const variantLabel = parts.length ? parts.join(" | ") : undefined;
              if (!preOrderPrazo && !variantLabel) return null;

              // Example: "Produto: Camiseta | Qtd: 2 | Cor: Preta | Tamanho: G — Janeiro/2026"
              if (preOrderPrazo && variantLabel) return `${variantLabel} — ${preOrderPrazo}`;
              return String(preOrderPrazo || variantLabel);
            })
            .filter(Boolean);

          // Deduplicate while preserving order
          const uniqueLines = deliveryLines.filter((d, idx) => deliveryLines.indexOf(d) === idx);

          let deliveryMessage;
          if (uniqueLines.length === 1) {
            deliveryMessage = `• ${uniqueLines[0]}`;
          } else if (uniqueLines.length > 1) {
            deliveryMessage = `Entregas previstas:\n${uniqueLines.map((d) => `• ${d}`).join("\n")}`;
          }
          window.BackorderDialogs.openPolicyTerms(deliveryMessage, () => {
            fetchAddToCart(addItems);
          });
          return;
        }
        fetchAddToCart(addItems);
      }

      getCart(callback) {
        const config = fetchConfig("javascript");
        fetch(`${routes.cart_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            callback(response);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      handleCartUpdated(items, sections) {
        if (!this.cart) return;

        if (window.CartFeedback) {
          window.CartFeedback.present(this.cart, { ...items[0], items, sections }, "kit");
        } else {
          items.forEach((item) => this.cart.renderContents({ ...item, sections }));
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

if (!customElements.get("kit-item")) {
  customElements.define(
    "kit-item",
    class KitVariantSelector extends HTMLElement {
      constructor() {
        super();

        this.index = this.dataset.index;
        this.quantity = Number(this.dataset.quantity);
        this.discount = Number(this.dataset.discount);
        this.kitHandle = this.getAttribute("data-kit-handle");
        this.filterModel = this.getAttribute("data-filter-model") == "true" ? true : false;

        this.discountPriceSpan = this.querySelector("span.discount-price");
        this.originalPriceSpan = this.querySelector("span.original-price");

        this.fieldsets = this.querySelectorAll("fieldset");
        this.productVariants = JSON.parse(this.querySelector("script[type='application/json']#variants").innerHTML);
        this.variantMetafields = JSON.parse(this.querySelector("script[type='application/json']#metafields").innerHTML);

        if (this.variantMetafields && this.variantMetafields.length > 0) {
          this.variantMetafields.forEach((metafield) => {
            const index = this.productVariants.findIndex((variant) => {
              return parseInt(variant.id) === parseInt(metafield.variant_id);
            });
            if (index > -1) {
              this.productVariants[index].metafield = metafield;
            }
          });
        }

        this.selectedOptions = {};
        this.querySelectorAll(`input[type="radio"]`).forEach((radio) => {
          if (!this.selectedOptions[radio.dataset.name]) {
            this.selectedOptions[radio.dataset.name] = {
              position: parseInt(radio.dataset.position),
              value: null,
            };
          }
        });
        this.productImagesKits = this.querySelectorAll(".kit-item__media img");

        // Handle price groups
        this.havePriceGroups = this.dataset.havePriceGroups === "true";
        this.kitProductHandle = this.dataset.kitProductHandle;
        this.variantSelector = this.closest("kit-variant-selector");
        this.priceAdjustment = 0;
        this.markdownAdjustment = 0;
        this.init();
      }

      init() {
        if (this.havePriceGroups && !this.priceAdjustment && !this.priceGroupId) {
          // get price group cookies
          const priceGroupCookie = this.getPriceGroupCookie(this.kitProductHandle);

          if (priceGroupCookie === "loading" || !priceGroupCookie) return this.setupPriceGroupListeners();
          if (priceGroupCookie.groupId !== "default") {
            this.priceAdjustment = priceGroupCookie.priceAdjustment;
            this.markdownAdjustment = priceGroupCookie.markdownAdjustment;
            this.priceGroupId = priceGroupCookie.groupId;
          }
        }

        if (this.variantSelector.discount) {
          this.discount = this.variantSelector.discount;
        }

        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();
      }

      /* Start price group handling */
      getPriceGroupCookie(productHandle) {
        const cookieName = `statsig-group-${productHandle}`;
        const cookieValue = document.cookie
          .split("; ")
          .find((row) => row.startsWith(cookieName))
          ?.split("=")[1];

        if (cookieValue === "loading") return "loading";
        if (!cookieValue) return null;
        return JSON.parse(cookieValue);
      }

      setupPriceGroupListeners() {
        document.addEventListener(`${this.kitProductHandle}-price-group-loaded`, ({ detail }) => {
          this.priceAdjustment = detail.priceAdjustment;
          this.markdownAdjustment = detail.markdownAdjustment;
          this.priceGroupId = detail.groupId;
          this.init();
        });
      }
      /* End price group handling */

      fnv32a(str, is64 = false) {
        let FNV1_32A_INIT = 0x811c9dc5;
        let hval = FNV1_32A_INIT;
        for (var i = 0; i < str.length; ++i) {
          hval ^= str.charCodeAt(i);
          hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
        }
        const result = ("0000000" + (hval >>> 0).toString(16)).substr(-8);
        if (!is64) return this.fnv32a(result + str + Math.random(0, 1000), true);
        return result;
      }

      onVariantChange(radio) {
        this.updateVariantStatuses();
        this.updateOptions();
        this.updateMasterId();
        this.changeImageKit(radio);
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset) => {
          const radios = Array.from(fieldset.querySelectorAll("input"));
          const checkedRadio = radios.find((radio) => radio.checked);

          if (checkedRadio) return checkedRadio.value;

          const firstExistingRadio = radios.find((radio) => !radio.classList.contains("not-exist"));
          if (firstExistingRadio) {
            firstExistingRadio.checked = true;
            return firstExistingRadio.value;
          }

          return undefined;
        });

        fieldsets.forEach((fieldset) => {
          const label = fieldset.querySelector(".form__label");
          const arrayWord = label.innerHTML.indexOf(":") > -1 ? label.innerHTML.split(":") : label.innerHTML;
          const nameLabel = Array.isArray(arrayWord) ? arrayWord[0] : arrayWord;
          const nameLabelLowerCase = nameLabel.toLowerCase();

          if (
            this.options[0] &&
            (nameLabelLowerCase.indexOf("cor") !== -1 ||
              nameLabelLowerCase.indexOf("color") !== -1 ||
              nameLabelLowerCase.indexOf("colour") !== -1)
          ) {
            label.innerHTML = `${nameLabel}: <span>${this.options[0]}</span>`;

            const optionValueSlug = slugify(this.options[0]);
            this.productImagesKits.forEach((image) => {
              const imgAltSlug = slugify(image.getAttribute("alt"));
              if (imgAltSlug.includes(optionValueSlug)) {
                image.classList.remove("hidden");
              } else {
                image.classList.add("hidden");
              }
            });

          }
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });

        if (this.currentVariant) {
          this.updatePrice(this.currentVariant.price, this.currentVariant.compare_at_price);
          if (typeof window.updateKitUpsellPriceNormalizeFromVariant === "function") {
            window.updateKitUpsellPriceNormalizeFromVariant(
              this.currentVariant.price,
              this.currentVariant.compare_at_price,
            );
          }
        } else {
          const firstVariant = this.getVariantData().find((variant) => {
            return variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(true);
          });
          this.updatePrice(firstVariant.price, firstVariant.compare_at_price);
          if (typeof window.updateKitUpsellPriceNormalizeFromVariant === "function") {
            window.updateKitUpsellPriceNormalizeFromVariant(firstVariant.price, firstVariant.compare_at_price);
          }
        }
      }

      formatMoney(cents) {
        // Keep kit-item calculation precise and round only the displayed value,
        // using the same upward whole-BRL rule as price-normalize.
        const normalizedCents = Math.round(Number(cents) * 1000000) / 1000000;
        const value = Math.ceil(normalizedCents / 100);
        return `R$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
      }

      updatePrice(originalPrice, compareAtPrice) {
        const baseOriginalPrice = Number(originalPrice ?? this.currentVariant?.price ?? 0);
        const baseCompareAtPrice = Number(compareAtPrice ?? this.currentVariant?.compare_at_price ?? baseOriginalPrice);
        const quantity = Number(this.quantity);
        const discount = Number(this.discount);
        const priceAdjustment = Number(this.priceAdjustment);

        const variantPrice = baseOriginalPrice + priceAdjustment;
        const discountedUnitPrice = discount > 0 ? variantPrice - (variantPrice * discount) / 100 : variantPrice;
        const finalCompareAtPrice = baseCompareAtPrice > 0 ? baseCompareAtPrice : variantPrice;

        const selector = this.closest("kit-variant-selector");
        // Compare integer cents, but never turn invalid/negative prices into a free item.
        const freeItem = selector?.dataset.schemaType === "buy-x-pay-y"
          && Number.isFinite(discountedUnitPrice) && discountedUnitPrice >= 0
          && discount >= 0 && discount <= 100
          && Math.round(discountedUnitPrice) === 0;
        this.discountPriceSpan.classList.toggle("kit-item__free-price", freeItem);
        this.discountPriceSpan.textContent = freeItem ? selector.dataset.freeLabel : this.formatMoney(discountedUnitPrice * quantity);
        this.discountPriceSpan.classList.remove("hidden");
        this.originalPriceSpan.innerHTML = this.formatMoney(finalCompareAtPrice * quantity);

        if (finalCompareAtPrice <= discountedUnitPrice) {
          this.originalPriceSpan.classList.add("hidden");
        } else {
          this.originalPriceSpan.classList.remove("hidden");
        }

        // Use the existing <price-normalize> element (do not instantiate the custom element class)
        const priceNormalize = document.querySelector("price-normalize");
        if (priceNormalize && typeof priceNormalize.changePriceCouponKit === "function") {
          priceNormalize.changePriceCouponKit(discountedUnitPrice, quantity, this);
        }
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        if (this.variantMetafields && this.variantMetafields.length > 0) {
          this.variantMetafields.forEach((metafield) => {
            const index = this.variantData.findIndex((variant) => {
              return parseInt(variant.id) === parseInt(metafield.variant_id);
            });
            if (index > -1) {
              this.variantData[index].metafield = metafield;
            }
          });
        }
        return this.variantData;
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(":checked")?.value === variant.option1,
        );
        const inputWrappers = [...this.querySelectorAll(".product-form__input")];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];

          let previousOptionSelected = inputWrappers[index - 1].querySelector(":checked")?.value;
          const existingOptionsInputsValue = selectedOptionOneVariants.map(
            (variantOption) => variantOption[`option${index + 1}`],
          );

          let availableOptionInputsValue = [];
          if (previousOptionSelected) {
            availableOptionInputsValue = selectedOptionOneVariants
              .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
              .map((variantOption) => variantOption[`option${index + 1}`]);
          } else {
            availableOptionInputsValue = selectedOptionOneVariants
              .filter((variant) => variant.available)
              .map((variantOption) => variantOption[`option${index + 1}`]);
          }

          this.setInputAvailability(optionInputs, availableOptionInputsValue, existingOptionsInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions, listOfExistingOptions) {
        listOfOptions.forEach((input) => {
          const inputValue = input.getAttribute("value");
          const variantExists = listOfExistingOptions.includes(inputValue);
          const isAvailable = listOfAvailableOptions.includes(inputValue);
          const optionWrapper = input.closest(".variant-option-space");

          input.classList.remove("not-exist");
          input.classList.remove("disabled");
          if (optionWrapper) {
            optionWrapper.classList.remove("not-exist");
          }

          if (!variantExists) {
            input.classList.add("not-exist");
            if (optionWrapper) {
              optionWrapper.classList.add("not-exist");
            }

            if (input.checked) {
              input.checked = false;
              const firstInputSamePosition = this.querySelector(
                `input[type="radio"][data-position="${input.dataset.position}"]:not(.not-exist)`,
              );
              if (firstInputSamePosition) {
                firstInputSamePosition.checked = true;
              }
            }

            return;
          }

          if (!isAvailable) {
            input.classList.add("disabled");
          }
        });

        const availableInputs = listOfOptions.filter((element) => !element.classList.contains("not-exist"));

        if (availableInputs.length === 1 && !availableInputs[0].checked) {
          availableInputs[0].checked = true;
        }
      }

      changeImageKit(radio) {
        const optionProductId = radio.getAttribute("data-product-id");
        const optionName = radio.dataset.name.toLowerCase();
        if (
          optionName.includes("cor") ||
          optionName.includes("color") ||
          optionName.includes("colour") ||
          optionName.includes("modelo")
        ) {
          this.productImages = document.querySelectorAll("media-gallery .product__media-item");

          let selectedColor = this.querySelectorAll(`input[type="radio"][data-position="1"]:checked`)[0];
          let selectedModel = this.querySelectorAll(`input[type="radio"][data-position="3"]:checked`)[0];

          if (selectedModel && selectedModel.classList.contains("not-exist")) {
            selectedModel = this.querySelectorAll(`input[type="radio"][data-position="3"]:not(.not-exist)`)[0];
            selectedModel.checked = true;
          }

          const selectedColorValue = slugify(selectedColor.value);
          const selectedModelValue = selectedModel ? "-" + slugify(selectedModel.value) : "";

          let name_value_slug = `${selectedColorValue}${selectedModelValue}`;
          let name_value = name_value_slug;

          const mediaGallery = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`) ?? null;
          if (mediaGallery) {
            const mediaGallerySlides = mediaGallery.querySelectorAll(".product__media-item");

            this.collection = mediaGallery.dataset.genderCollection ?? null;

            if (this.collection) {
              const variantOptionsCollection = `${optionProductId}-${name_value}-${this.collection}`;

              const imagesGallery = Object.keys(mediaGallerySlides).map((key) => mediaGallerySlides[key]);
              const ifImagesCollection = imagesGallery.find((slide) => {
                const slideAlt = slide.getAttribute("data-media-alt");
                return variantOptionsCollection == slideAlt;
              });

              name_value = ifImagesCollection ? `${name_value}-${this.collection}` : name_value_slug;
            }
          }
          if (document.querySelectorAll(`li[data-media-alt='${optionProductId}-${name_value}']`).length == 0) {
            name_value = `${selectedColorValue}`;
          }

          this.productImages.forEach((image) => {
            let slideAlt = image.getAttribute("data-media-alt");
            const productId = image.getAttribute("data-product-id");

            const [altId, ...altVariant] = slideAlt.split("-");

            if (altVariant.length) {
              slideAlt = altVariant.join("-");
            }

            if (!this.filterModel) {
              if (slideAlt.includes(name_value) && productId == optionProductId) {
                image.setAttribute("style", `display: block !important`);
              } else {
                image.style.display = "none";
              }
            } else {
              if (slideAlt == name_value && productId == optionProductId) {
                image.setAttribute("style", `display: block !important`);
              } else {
                image.style.display = "none";
              }
            }
          });

        }
      }

      optionsHaveBeenSelected() {
        let selected = true;
        this.fieldsets.forEach((fieldset) => {
          selected = selected && fieldset.querySelector("input:checked:not(.not-exist):not(.disabled)") != null;
        });
        return selected;
      }

      getSelectedVariant(totalQty) {
        const properties = {
          // _key: this.fnv32a(this.currentVariant.id + this.quantity),
          // handlesKit: {
          //   discount: this.discount,
          //   name: this.kitHandle,
          //   totalQty,
          // },
          ...(this.currentVariant.selling_plan_allocations.length && {
            "_Esse produto será despachado a partir de":
              this.currentVariant.selling_plan_allocations[0]?.selling_plan?.name?.replace(
                "Compra antecipada: envio a partir de ",
                "",
              ),
            __backorder_app: this.currentVariant.selling_plan_allocations[0]?.app_id,
          }),
        };

        if (this.priceGroupId) {
          properties["_price_group"] = this.priceGroupId;
          properties["_adjustment"] = this.priceAdjustment;
        }

        if (this.currentVariant?.compare_at_price) {
          properties["_compare_at_price"] = (this.currentVariant.compare_at_price / 100).toFixed(2);
        }

        const priceNormalize = document.querySelector("price-normalize");
        if (priceNormalize) {
          const kitCompareAtPrice = parseFloat(priceNormalize.dataset.compareAtPrice);
          const kitFinalPrice = parseFloat(priceNormalize.dataset.kitFinalPrice);
          if (kitCompareAtPrice) {
            properties["_kit_compare_at_price"] = (kitCompareAtPrice / 100).toFixed(2);
          }
          if (kitFinalPrice) {
            properties["_kit_final_price"] = kitFinalPrice.toFixed(2);
          }
        }

        return {
          id: this.currentVariant.id,
          quantity: this.quantity,
          properties,
          ...(this.currentVariant.selling_plan_allocations.length && {
            selling_plan: Number(this.currentVariant.selling_plan_allocations[0].selling_plan_id),
          }),
        };
      }
      triggerInitialGalleryState() {
        const firstKitItem = this.kitItems[0];
        if (!firstKitItem) return;

        const selectedColorRadio =
          firstKitItem.querySelector('input[type="radio"][data-name="Cor"]:checked') ||
          firstKitItem.querySelector('input[type="radio"][data-name="Color"]:checked') ||
          firstKitItem.querySelector('input[type="radio"][data-name="Colour"]:checked');

        if (selectedColorRadio) {
          selectedColorRadio.dispatchEvent(new Event("change", { bubbles: true }));
          return;
        }

        const firstCheckedRadio = firstKitItem.querySelector('input[type="radio"]:checked');
        if (firstCheckedRadio) {
          firstCheckedRadio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    },
  );
}
